<template>
  <div class="pageContainer app-container bdDetail">
    <el-row class="">
      <el-form :inline="true" :model="searchForm" style="margin-top: 10px">
        <el-input v-model="searchForm.stu_name" placeholder="学生姓名" size="small" style="width: 200px;"></el-input>
        <el-cascader ref="firstCascader" :options="treeData" :props="treeProps1" size="small"
                     v-model="searchForm.class_id" :show-all-levels="true" @change="handleCascaderChange" placeholder="班级"
                     style="width: 410px;margin: 0 10px;" filterable clearable></el-cascader>
        <el-button size="small" icon="el-icon-search" @click="onSearch" plain type="primary">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="onReset" type="warning">重置</el-button>
        <el-button size="small" icon="el-icon-document-copy" @click="exportXLS" style="margin-left: 20px;">导出班级表单</el-button>
<!--        <el-button size="small" icon="el-icon-picture-outline" @click="exportImg" style="margin-left: 20px;">导出班级图片</el-button>-->

      </el-form>
    </el-row>
    <el-row type="flex" :gutter="16" style="margin-top: 20px">
      <el-col :span="24" class="tabContainer">
        <el-tabs v-model="activeName" type="border-card" style="height: 100%">
          <el-tab-pane style="position: relative;" v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">
			  <div style="text-align: right; padding-bottom: 10px;">
				 <el-link  type="primary" target="_blank" style="margin-right: 10px;" @click="downFile(1)">表单1</el-link>
				  <el-link  type="primary" target="_blank" style="margin-right: 10px;" @click="downFile(2)">表单2</el-link>
				   <el-link  type="primary" target="_blank" style="margin-right: 10px;" @click="downFile(3)">表单3</el-link>
				    <el-link  type="primary" target="_blank" style="margin-right: 10px;" @click="downFile(4)">表单4</el-link>
			  </div>
            <el-table :data="tableData" stripe size="mini" style="width: 100%; margin-bottom: 20px" border>
              <el-table-column prop="index" width="55" label="序号">
                <template slot-scope="scope">
                  {{ scope.$index + 1 + page.pageSize * (page.pageIndex - 1) }}
                </template>
              </el-table-column>
              <el-table-column prop="stu_name" label="姓名" width="80"></el-table-column>
              <el-table-column prop="phone" label="电话" width="110"></el-table-column>
              <el-table-column prop="yuanxi_name" label="系部"></el-table-column>
              <el-table-column prop="major_name" label="专业"></el-table-column>
              <el-table-column prop="class_name" label="班级"></el-table-column>
              <el-table-column prop="class_name" label="状态" width="80">
                <template slot-scope="scope">
                  <span style="color: #409eff;">{{scope.row.bd_status==1?'已填':''}}</span>
                  <span>{{scope.row.bd_status==0?'未填':''}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="140">
                <template slot-scope="scope">
                  <el-button @click="showDialog(scope.row)" icon="el-icon-view" type="text" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handlePageChange"
              :current-page="page.pageIndex"
              :page-size="page.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="page.total"
            >
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-dialog :title="modalTitle" width="800px" :visible.sync="visible" :close-on-click-modal="false" center>
<!--      <iframe src="./bd?pmid=5&openid=123" frameborder="0" style="width:480px;height:1000px"></iframe>-->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基础信息</span>

        </div>
        <div>
      <el-form :model="editForm" inline ref="adminUserInfo" label-width="85px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="建档号：">{{editForm.archive||'-'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考试证号：">{{editForm.exam_num||'-'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学生姓名：">{{editForm.stu_name||'-'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号：">{{editForm.identity_card||'-'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别：">{{editForm.gender==1?'男':'女'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生日期：">{{editForm.birthday||'-'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专业：">{{editForm.major_name||'-'}}</el-form-item>
          </el-col>
          <el-col :span="12" >
            <el-form-item label="录取性质：">{{editForm.nianzhi||'-'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="毕业地区：">{{editForm.graduate_sch_city||'-'}}</el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中考成绩：">{{editForm.exam_score||'-'}}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="毕业学校：">{{editForm.school_name||'-'}}</el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="第几志愿：">
              <span v-if="editForm.volunteer==1">第一志愿</span>
              <span v-if="editForm.volunteer==2">第二志愿</span>
              <span v-if="editForm.volunteer==0">无志愿</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式：" prop="phone">{{editForm.phone||'-'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备用手机：" prop="phone2">{{editForm.phone2||'-'}}</el-form-item>
          </el-col>
          <el-col :span="12" v-if="$store.state.pmid!=2">
            <el-form-item label="是否住宿：" prop="dorm"> {{editForm.dorm==1?'住宿':'不住宿'}}</el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="备注：" prop="remark">{{editForm.remark||'-'}}</el-form-item>
          </el-col>
        </el-row>

      </el-form>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 20px;margin-bottom: 50px">
        <div slot="header" class="clearfix"><span>报道表单</span></div>
        <div>
          <div v-for="(item,index) in forms" style="margin-bottom: 20px;" class="flexStart">
            <a @click="goPrint(item)" href="javascript:;" :class="item.table_detail?'fill':'blank'">{{ item.table_name }}</a>
            <span class="blank" style="color: #999" v-if="!item.table_detail">（暂未填写）</span>
          </div>
        </div>
      </el-card>
      <div slot="footer">
        <el-button type="primary" @click="visible = false">关闭</el-button>
      </div>
    </el-dialog>


<!--    打印单-->
    <uniformPrint v-if="show_uniform" :title="dialogTitle" :detailInfo="detailInfo" :baseInfo="baseInfo"></uniformPrint>
    <dormPrint v-if="show_dorm" :title="dialogTitle" :detailInfo="detailInfo" :baseInfo="baseInfo"></dormPrint>
    <otherPrint v-if="show_otherInfo" :title="dialogTitle" :detailInfo="detailInfo" :baseInfo="baseInfo"></otherPrint>
    <phonePrint v-if="show_phone" :title="dialogTitle" :detailInfo="detailInfo" :baseInfo="baseInfo"></phonePrint>
    <stuInfoPrint v-if="show_stuInfo" :title="dialogTitle" :detailInfo="detailInfo" :baseInfo="baseInfo"></stuInfoPrint>
    <healthPrint v-if="show_health" :title="dialogTitle" :detailInfo="detailInfo" :baseInfo="baseInfo"></healthPrint>
  </div>
</template>

<script>
import uniformPrint from "./bdPrint/Print_uniform.vue"
import dormPrint from "./bdPrint/Print_dorm.vue"
import otherPrint from "./bdPrint/Print_other.vue"
import phonePrint from "./bdPrint/Print_phone.vue"
import stuInfoPrint from "./bdPrint/Print_stuInfo.vue"
import healthPrint from "./bdPrint/Print_health.vue"


export default {
  name: "BD",
  components: {uniformPrint,dormPrint,otherPrint,phonePrint,stuInfoPrint,healthPrint},
  data() {
    return {
      visible: false,
      modalTitle: "详情",
      searchForm: {
        stu_name: "",
        banji: '',
        class_id:''
      },
      editForm: {
        username: "",
        table_code: "",
        table_name: "",
      },
      page: {
        pageIndex: 1,
        pageSize: 20,
        total: 0,
      },
      //table
      tabMapOptions: [{ label: "新生报道表列表", key: "CN" }],
      activeName: "CN",
      tableData: [],
      pmid: 5,
      treeData:[],
      treeData1: [],
      treeProps1: {
        children: 'children',
        label: 'title',
        value: 'id',
        // checkStrictly: true,
        emitPath: false,
      },

      forms:[],
      show_dorm:false,
      show_health:false,
      show_otherInfo:false,
      show_perInfo:false,
      show_stuInfo:false,
      show_uniform:false,
      show_phone:false,
      dialogTitle:'打印',

      baseInfo:{},
      detailInfo:{},
    };
  },
  mounted() {
    if (sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      this.pmid = userinfo && userinfo.pmid ? userinfo.pmid : this.pmid;
    }
    this.getList();
    this.getOrgList();
  },
  methods: {
    getOrgList() {
      let _this = this
      this.$http.post("/api/sch_major_list_and_num").then(res => {
        if (res.data && res.data.length > 0) {
          _this.deleteEmptyGroup(res.data).then(result => {
            this.treeData = result
            // _this. searchForm.class_id =  result[0].children[0].children[0].id
            // this.getList();
            return
            let result1 = JSON.parse(JSON.stringify(result))
            if (result1 && result1.length > 0) {
              result1.map(xibu => {
                if (xibu.children && xibu.children.length > 0) {
                  xibu.children.map(major => {
                    if (major.children) {
                      delete major.children
                    }
                  })
                }
              })
              this.treeData1 = result1
            }
          })
        }
      })
    },
    // 处理没有children的分组
    deleteEmptyGroup(treeData) {
      return new Promise(resolve => {
        function traversal(data) {
          data.map(item => {
            for (let info in item) {
              if (item['children']) {
                if (item['children'].length > 0) {
                  traversal(item['children'])
                }
                if (item['children'].length == 0) {
                  delete item['children']
                }
              }
            }
          })
        }

        traversal(treeData)
        resolve(treeData)
      })
    },

    onSearch() {
      this.tableData = [];
      this.page.pageIndex = 1;
      this.getList();
    },
    onReset() {
      this.searchForm = {
        stu_name: "",
        banji: '',
        class_id:''
      };
      this.tableData = [];
      this.page.pageIndex = 1;
      this.getList();
    },
    getList() {
      let params = {
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        list_type: 0,
        status: "all",
        stu_type: 0,
        ...this.searchForm
      };
      if (this.searchForm.stu_name) {
        params.ktype = 'stu_name'
        params.keyword = this.searchForm.stu_name
      }

      this.$http.post("/api/sch_students_baodao_list", params).then((res) => {
        this.tableData = res.data.data;
        this.page.total = res.data.page.count;
        // if(res.data.data&&res.data.data.length>0){
        //
        // }
      });
    },
    showDialog(row) {
      this.modalTitle = "详情";
      this.visible = true;
      this.getStuInfo(row)
      this.getForms(row)
    },
    getStuInfo(row){
      let _this = this
      return new Promise(resolve => {
        this.$http.post("/api/stu_luqu_detail", {
          stu_id: row.id,
          pmid: this.pmid
        }).then(res => {
          console.log(res.data)
          if(res.data){
            _this.editForm = {...res.data}
            console.log(_this.editForm)
          }
          resolve()
        })
      })
    },
    getForms(row){
      let _this = this
      let arr = []
      return new Promise(resolve => {
        this.$http.post('/api/t_stu_check_in_table_list', {
          pmid: _this.pmid,
          stu_id: row.id
        }).then(res => {
          res.data.data&&res.data.data.length>0&&res.data.data.map(r=>{
            if(r.STOP==0){
              arr.push(r)
            }
          })
          _this.forms = arr
          resolve()
        })
      })
    },

    goPrint(row){
      this.show_dorm = false
      this.show_health = false
      this.show_otherInfo = false
      this.show_perInfo = false
      this.show_stuInfo = false
      this.show_uniform = false
      this.show_phone = false
      if(row.table_detail){
        this.dialogTitle = row.table_name
        this.baseInfo = row
        this.detailInfo = JSON.parse(row.table_detail)
        if(row.table_name.indexOf('身体状况')!=-1){
          this.show_health = true
        }
        if(row.table_name.indexOf('校服')!=-1){
          this.show_uniform = true
        }
        if(row.table_name.indexOf('学生信息')!=-1){
          this.show_stuInfo = true
        }
        if(row.table_name.indexOf('个人信息')!=-1){
          this.show_perInfo = true
        }
        if(row.table_name.indexOf('其他信息')!=-1){
          this.show_otherInfo = true
        }
        if(row.table_name.indexOf('住宿')!=-1){
          this.show_dorm = true
        }
        if(row.table_name.indexOf('携带手机')!=-1){
          this.show_phone = true
        }

      }
    },
    closePrint(){
      this.show_dorm = false
      this.show_health = false
      this.show_otherInfo = false
      this.show_perInfo = false
      this.show_stuInfo = false
      this.show_uniform = false
    },
    handlePageChange(e) {
      this.page.pageIndex = e;
      this.getList();
    },
    handleCascaderChange(e, opt) {
      //console.log(e, this.$refs['firstCascader'].panel.getNodeByValue(e))
      if(e){
        this.searchForm.banji = this.$refs['firstCascader'].panel.getNodeByValue(e).label
      }else {
        this.searchForm.banji = ''
      }
    },
    exportXLS(){
      if (!this.searchForm.class_id) {
        this.$message({
          showClose: true,
          message: '请选择班级再导出!',
          type:"warning"
        })
      }
      else {
        let params = {
          class_name: this.searchForm.banji,
          class_id: this.searchForm.class_id,
          // stu_ids:'14421,14422,14425',
          pmid: this.pmid,
        }
        this.$http.post("/api/exportWord1", params).then((res) => {
          console.log(res.data.url)
          let downloadUrl = res.data.url
          if(downloadUrl){
            let urlArr = downloadUrl.split('/')
            let nameArr = urlArr[3].split('.')
            let filename = encodeURIComponent(nameArr[0])
            let file_url = `${urlArr[0]}/${urlArr[1]}/${urlArr[2]}/${filename}.${nameArr[1]}`
            window.open(file_url);
          }else {
            this.$message({
              showClose: true,
              message: '下载失败，请重试!',
              type:"danger"
            })
          }


        });

      }
    },
    exportImg(){
      if (!this.searchForm.class_id) {
        this.$message({
          showClose: true,
          message: '请选择班级再导出!',
          type:"warning"
        })
      }
      else {
        let params = {
          class_name: this.searchForm.banji,
          class_id: this.searchForm.class_id,
          pmid: this.pmid,
        }
        this.$http.post("/api/exportImg", params).then((res) => {
          console.log(res.data.url)
          let downloadUrl = res.data.url
          if(downloadUrl){
            let urlArr = downloadUrl.split('/')
            let nameArr = urlArr[3].split('.')
            let filename = encodeURIComponent(nameArr[0])
            let file_url = `${urlArr[0]}/${urlArr[1]}/${urlArr[2]}/${filename}.${nameArr[1]}`
            window.open(file_url);
          }else {
            this.$message({
              showClose: true,
              message: '下载失败，请重试!',
              type:"danger"
            })
          }


        });

      }
    },
	downFile(type){

		if(this.searchForm.class_id){
			this.$http.post("/api/export_cls_stu"+type,this.searchForm).then(res=>{
				if(res.data.url){
					let filename = res.data.url.split(".com/");
					let filename2= filename[1].split(".")
					let url = filename[0]+".com/"+encodeURIComponent(filename2[0])+"."+filename2[1]
					console.log(url)
					window.open(url,"_blank")
				}
			})
		}else{
			this.$message({
			  showClose: true,
			  message: '请先选择班级',
			  type:"danger"
			})
		}


	}
  },
};
</script>

<style scoped lang="less" type="text/less">
.bdDetail {
  .el-form-item {
    margin-bottom: 10px !important;
  }

  .fill {
    cursor: pointer;
    text-decoration: underline;
    color: #1370FB;
  }

  .blank {
    cursor: default;
    text-decoration: none;
    color: #777;
  }

}
</style>
